import * as React from "react";
import Typography from "@mui/material/Typography";
import { ScreeningsData } from "../../types/dataTypes.ts";
import { Box } from "@mui/material";
import { ScreeningsForOneDate } from "./ScreeningsForOneDate.tsx";

interface ScreeningsForPopularFilmPageProps {
  screenings: ScreeningsData[];
  filmTitle: string;
}

export const ScreeningsForPopularFilmPage: React.FC<
  ScreeningsForPopularFilmPageProps
> = ({ screenings, filmTitle }) => {
  return (
    <>
      {screenings.map(({ screenings_date_label, screenings }) => (
        <Box
          sx={{
            marginBottom: 5,
            marginLeft: 0,
            marginRight: 0,
          }}
          key={`${filmTitle}-${screenings_date_label}`}
        >
          <Typography
            sx={{
              fontSize: { xs: "large", md: "large" },
              fontWeight: "bold",
            }}
          >
            {screenings_date_label}
          </Typography>

          <ScreeningsForOneDate screenings={screenings} filmTitle={filmTitle} />
        </Box>
      ))}
    </>
  );
};
